export default __webpack_public_path__ + "static/media/mac.348e84b8.svg";